export function drill(searchObject: any, address: Array<string>): any {
  return address.reduce((o, field) => o && o[field], searchObject);
}

export default {
  drill,
};
